//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Button from '@/components/Shared/Button.vue'
import { mapGetters } from 'vuex'
import { showSuccessNotification } from '~/util/notifications'

export default {
  name: 'StepFive',
  components: {
    Button,
  },
  data() {
    return {
      baseUrl: process.env.NUXT_ENV_SEO_URL || 'http://0.0.0.0:3000',
      projectCode: null,
    }
  },
  computed: {
    ...mapGetters({
      getBaseProject: 'project/getBaseProject',
    }),
    urlProject() {
      return `${this.baseUrl}/invitacion/${this.projectCode}`
    },
  },
  watch: {
    'getBaseProject.id': {
      handler(newId) {
        if (newId) {
          this.fetchProjectCode()
        }
      },
      immediate: true,
    },
  },
  methods: {
    async fetchProjectCode() {
      const project = await this.$repository.project.findOne(
        this.getBaseProject.id
      )
      this.projectCode = project.code
    },
    goToProjectDetail() {
      this.$router.push(`/mis-proyectos/${this.getBaseProject.id}`)
      showSuccessNotification(
        this,
        this.$t('projects.new.steps.fifth.success'),
        5000
      )
    },
  },
}
